import { render, staticRenderFns } from "./CorrespondenceLetterList.vue?vue&type=template&id=b9ded9a0"
import script from "./CorrespondenceLetterList.vue?vue&type=script&lang=js"
export * from "./CorrespondenceLetterList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports